import DbConfig from '../../../config/DbConfig.js'
import {rtrim} from '../../functions/Common.js'

/**
 * 根据客服id，粉丝id，获取标签列表
 * @param {Object} custom_id
 * @param {Object} friend_id
 * @param {Object} callback
 */
export function getFansTagsByCFid(custom_id,friend_id,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_custom_friends_tags where custom_id = ? and friend_id = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[custom_id,friend_id],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		},(tx,error)=>{
			callback([])
		})
	})
}

// 根据粉丝id，删除粉丝标签
export function deleteFansTagsByFansId(friend_id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_custom_friends_tags where friend_id = '+ friend_id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 根据粉丝id，删除粉丝标签
export function insertFansTags(tagList,callback){
	let db = DbConfig.connect()
	let sql = 'insert into yswl_custom_friends_tags(id,custom_id,friend_id,tag_value) values'
	for (let i = 0; i < tagList.length; i++) {
		sql += '('+tagList[i].id+','+tagList[i].custom_id+','+tagList[i].friend_id+',"'+tagList[i].tag_value+'"),'
	}
	sql = rtrim(sql,',')
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}